import { cn } from "common/utils/utils";

export const BackwardButton = ({
  onClick,
  className,
  iconSrc,
}: {
  onClick: () => void;
  className?: string;
  iconSrc?: string;
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        "flex h-[80px] w-[80px] items-center justify-center rounded-full border border-[#FFF3ED]",
        className,
      )}
    >
      <img
        src={iconSrc ?? "/assets/icons/arrow-left-rounded.svg"}
        alt="arrow-left"
        className="h-[24px] w-[24px]"
      />
    </button>
  );
};

export const ForwardButton = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        "flex h-[80px] w-[80px] items-center justify-center rounded-full bg-[#4FBA6D]",
        className,
      )}
    >
      <img src="/assets/icons/arrow-right-rounded.svg" alt="arrow-right" />
    </button>
  );
};
